import React, {createContext, useCallback, useContext, useEffect, useRef, useState} from 'react'
import {bankRequest, ReconciliationData} from '../reconciliationApi'

const empty: ReconciliationData = {
  bills: [],
  payments: [],
  templates: [],
  reconciliations: [],
  asOf: '',
}
const Context = createContext({
  data: empty,
  loading: true,
  refreshing: false,
  error: '',
  refresh: async (_afterWrite?: boolean) => {},
})
export function ReconciliationProvider({children}: {children: React.ReactNode}) {
  const [data, setData] = useState(empty),
    [loading, setLoading] = useState(true),
    [refreshing, setRefreshing] = useState(false),
    [error, setError] = useState('')
  const flight = useRef<Promise<void> | null>(null)
  const refresh = useCallback((afterWrite = false): Promise<void> => {
    if (flight.current) return afterWrite ? flight.current.then(() => refresh()) : flight.current
    const work = (async () => {
      setRefreshing(true)
      setError('')
      try {
        setData(await bankRequest('overview'))
      } catch (e: any) {
        setError(e.message)
      } finally {
        setLoading(false)
        setRefreshing(false)
      }
    })()
    flight.current = work
    void work.finally(() => {
      if (flight.current === work) flight.current = null
    })
    return work
  }, [])
  useEffect(() => {
    void refresh()
  }, [refresh])
  return (
    <Context.Provider value={{data, loading, refreshing, error, refresh}}>
      {children}
    </Context.Provider>
  )
}
export const useReconciliation = () => useContext(Context)
